const verification = {
  success: 'Successfully verified',
  warning: 'You must confirm your email address in order to view your profile.',
}

export default verification
